<script lang="ts">
export default { name: 'LayoutHeader', inheritAttrs: false }
</script>

<script lang="ts" setup>
import { ref, inject, onMounted, onBeforeUnmount } from 'vue'
import { LayoutDataKey } from './use-layout-data'

const layout = inject(LayoutDataKey)

/** ヘッダー要素 */
const headerEl = ref<HTMLElement | null>(null)

/** ResizeObserver */
const observer = ref<ResizeObserver | null>(null)

onMounted(() => {
  if (headerEl.value && layout) {
    observer.value = new ResizeObserver(entries => {
      for (const entry of entries) {
        layout.header.height = entry.contentRect.height
      }
    })
    observer.value.observe(headerEl.value)
  }
})

onBeforeUnmount(() => {
  observer.value?.disconnect()
})
</script>

<template>
  <header ref="headerEl" class="fixed top-0 inset-x-0 z-10 w-full">
    <slot />
  </header>
</template>
